import request from './api'
import StorageService from '../services/storage.service'
const FingerprintJS = require('@fingerprintjs/fingerprintjs')

export async function generateFingerpint() {
  const fpPromise = FingerprintJS.load()
  const fp = await fpPromise
  const result = await fp.get()
  return result.visitorId
}

export async function signIn(email, password, fingerprint) {
  try {
    const res = await request('/api/account/login', 'POST', {
      login: email,
      password: password,
      fingerprint: fingerprint
    })

    if (res && res.status) {
      return {
        isOk: false,
        message: res.message,
        status: res.status
      }
    }

    if (res && res.userId) {
      return {
        isOk: true,
        data: res
      }
    }
    else return {
      isOk: false,
      message: res?.message ? res.message : 'Неизвестная ошибка! Возможно, сервер недоступен.'
    }
  }
  catch(e) {
    return {
      isOk: false,
      message: e.message
    }
  }
}

export async function getAuthSettings() {
  try {
    const res = await request('/api/account/get-auth-settings', 'GET', null)
    return {
      isOk: true,
      data: res.data
    }
  }
  catch(e) {
    throw new Error(e.message || 'Что-то пошло не так')
  }
}

const fixPhone = (phone) => '+7' + phone.replace(/\D/g, '').slice(-10);

export async function sendPhone(PhoneNumber, typeOp, fingerprint, rk) {
  try {
    PhoneNumber = fixPhone(PhoneNumber)
    const res = await request('/api/account/phone', 'POST', {PhoneNumber, typeOp, fingerprint, rk})
    if (res.uid) {
      return res
    } else {
      return res
    }
  }
  catch(e) {
    return {
      isOk: false,
      message: e.message
    }
  }
}

export async function sendPhoneChange(PhoneNumber, fingerprint) {
  try {
    PhoneNumber = fixPhone(PhoneNumber)
    const res = await request('/api/account/phone-change', 'POST', {PhoneNumber, fingerprint})
    return res
  }
  catch(e) {
    return {
      isOk: false,
      message: e.message
    }
  }
}

export async function sendPhoneCode(PhoneCode, PhoneNumber, uid, typeOp, fingerprint, userId) {
  try {
    PhoneNumber = fixPhone(PhoneNumber)
    const res = await request('/api/account/phonecode', 'POST', {PhoneCode, PhoneNumber, uid, typeOp, fingerprint, userId})
    if (res.isOk) {
      return res
    } else {
      return res
    }
  }
  catch(e) {
    return {
      isOk: false,
      message: e.message
    }
  }
}

export async function sendEmail(email) {
  try {
    // Send request
    const res = await request('/api/account/update-email','POST',{email})

      return {
        isOk: true,
        data: res
      };
  }
  catch (e) {
    return {
      isOk: false,
      message: e.message
    };
  }
}

export async function logout() {
  try {
    const localAuth = StorageService.getLocalAuth()
    await request('/api/account/logout','POST',{
      fingerprint: localAuth && localAuth.fingerprint
    })
  } catch (e) {

  }
  StorageService.removeLocalAuth()
}

export async function getUser() {
  try {
    // Send request
    const res = await request('/api/account/user','GET',null)

    if (res && res.id) {
        return {
        isOk: true,
        data: res
      };
    } else return {
      isOk: false
    }

  }
  catch {
    return {
      isOk: false
    };
  }
}

export async function createAccount(region, email, password, phone, last_name, first_name, middle_name, confirmed_password, inn, fromPhoneAuth, fingerprint) {
  try {
    // Send request
    const data = await request('/signup', 'POST',
        {
          region: region,
          email: email,
          phone: phone,
          fio_f: last_name,
          fio_i: first_name,
          fio_o: middle_name,
          pass: password,
          pass_confirm: confirmed_password,
          inn,
          fromPhoneAuth,
          fingerprint
        }
    )
    if (!fromPhoneAuth) {
      return {
        isOk: true,
        message: data.message
      };
    } else if (fromPhoneAuth && data.isOk) {
      return {
        isOk: true,
        data: data,
        message: data.message
      };
    }
  }
  catch (e) {
    return {
      isOk: false,
      message: e.message
    };
  }
}

export async function confirmAccount(userId, confirmCode) {
  try {
    const result = await request('/signup/check_token', 'POST',
        {
          user: userId,
          token: confirmCode
        }
    )
    if (result) {
      return {
        isOk: true,
        message: result.message
      }
    } else {
      return {
        isOk: false,
        message: result.message
      }
    }
  } catch (e) {
    return {
      isOk: false,
      message: e.message
    }
  }
}

export async function changePassword(password, recoveryCode, isset) {

  //todo если делать мгновенную авторизацию, то продумать подключение отпечатка к.
  // общей схеме
  const fingerprint = await generateFingerpint()

  try {
    // Send request
    const result = await request('/api/account/password/restore', 'POST',
      {
        token: recoveryCode,
        password: password,
        fingerprint: fingerprint,
        isset
      }
    )

    return {
      isOk: true,
      message: result.message
    };
  }
  catch (e) {
    return {
      isOk: false,
      message: e.message
    }
  }
}

export async function resetPassword(email, company) {
  try {
    var params = '?email=' + email
    if (company) params = params + '&company=' + company
    const result = await request('/api/account/password/restore' + params, 'GET', null)

    if (result)
      return {
        isOk: true,
        message: result.message
      };
  }
  catch (e) {
    console.error(e)
    return {
      isOk: false,
      message: e.message
    };
  }
}

export async function checkRecoveryCode(recoveryCode) {
  try {
    const result = await request('/api/account/password/check-recovery', 'POST', {recovery: recoveryCode})
    return {
      isOk: true,
      data: result
    };
  }
  catch (e) {
    console.error(e)
    return {
      isOk: false,
      message: e.message
    };
  }
}

export async function updateUser(form) {
  const lastName = form.Фамилия
  const firsName = form.Имя
  const middleName = form.Отчество
  const mobilePhone = form.phone
  const region = form.region

  try {
    const data = await request('/api/account/user','PUT', {
      firstName: firsName,
      lastName: lastName,
      middleName: middleName,
      mobilePhone: mobilePhone,
      region: region
    })
    return {
      isOk: true,
      data: data
    }
  } catch (e) {
    return {
      isOk: false,
      message: e.message
    }
  }
}

export async function updatePassword(currPass, newPass) {
  if (!currPass || !newPass)
    return {
      isOk: false,
      message: 'Заполните все поля!'
  }
  try {
    const data = await request('/api/account/password','PATCH', {
        currentPassword: currPass,
        newPassword: newPass
    })
    return {
      isOk: true,
      message: data.message
    }
  } catch (e) {
      return {
        isOk: false,
        message: e.message
      }
  }
}

export async function syncUser(kod_dog, period_s, period_po) {

  try {
    const data = await request('/api/account/sync-user','POST', {kod_dog, period_s, period_po})
    return {
      isOk: true,
      message: data.message
    }
  } catch (e) {
    return {
      isOk: false,
      message: e.message
    }
  }
}

export async function getSyncStatus() {
  try {
    const data = await request('/api/account/sync-status', 'GET')
    return {
      isOk: true,
      running: !!data?.running,
      message: data?.message || ''
    }
  } catch (e) {
    return {
      isOk: false,
      running: false,
      message: e.message
    }
  }
}

export async function deleteAccount() {
  try {
    const result = await request('/api/account/delete', 'POST', null)

    if (result)
      return {
        isOk: true,
        message: result.message
      };
  }
  catch (e) {
    console.error(e)
    return {
      isOk: false,
      message: e.message
    };
  }
}
